import React from 'react';
import { SiteSections } from './SiteSections';
import { ISiteSectionEntry } from '../../../../contentful/types/ISiteSection';
import { StyledContentWrap, Wrapper } from './SiteSections.styles';
import { MainNavigationWrapper } from '../shared/MainNavigationWrapper';
import { MainNavigationItems } from '../shared/MainNavigationItems';

interface IProps {
	siteSections: ISiteSectionEntry[];
	currentSiteSection?: ISiteSectionEntry;
	onSiteSectionIdChange: (id: string) => void;
	siteSectionId?: string;
	isSticky: boolean;
	homeUrl: string;
}

export default function DesktopNavigation({
	siteSections,
	siteSectionId,
	currentSiteSection,
	isSticky,
	onSiteSectionIdChange,
	homeUrl,
}: IProps) {
	const currentSiteSectionItem = siteSections.find(
		(section) => section.fields.id === currentSiteSection?.fields.id,
	);

	return (
		<Wrapper>
			<StyledContentWrap>
				<nav aria-label="Site sections">
					<SiteSections
						siteSections={siteSections}
						currentSiteSectionId={currentSiteSection?.fields.id}
						onSiteSectionIdChange={onSiteSectionIdChange}
						collapsed={isSticky}
					/>
				</nav>
			</StyledContentWrap>

			{currentSiteSectionItem && currentSiteSectionItem.fields?.menuItems && (
				<MainNavigationWrapper
					siteSectionId={siteSectionId}
					isSticky={isSticky}
					backgroundVariant="dark"
					homeUrl={homeUrl}
				>
					<MainNavigationItems
						items={currentSiteSectionItem.fields.menuItems}
						siteSectionId={siteSectionId}
					/>
				</MainNavigationWrapper>
			)}
		</Wrapper>
	);
}
